import stickybits from 'stickybits';

document.addEventListener('DOMContentLoaded', () => {
  const els = document.querySelectorAll('.js-sticky');
  const topbar = document.querySelector('.js-topbar');

  if (!els.length || !topbar) return;

  const getBaseOffset = () => {
    return topbar.clientHeight || 100;
  };

  let instances = [];

  const initSticky = () => {
    instances = [];

    els.forEach(el => {
      const manualOffset = el.dataset.offset
        ? parseInt(el.dataset.offset, 10)
        : 0;

      const disableBelow = el.dataset.disableBelow
        ? parseInt(el.dataset.disableBelow, 10)
        : null;

      const offset = getBaseOffset() + manualOffset;

      if (!disableBelow) {
        instances.push(
          stickybits(el, {
            stickyBitStickyOffset: offset
          })
        );
        return;
      }

      const mq = window.matchMedia(`(min-width: ${disableBelow}px)`);

      const toggleSticky = e => {
        if (e.matches) {
          if (!instances.includes(el)) {
            instances.push(
              stickybits(el, {
                stickyBitStickyOffset: offset
              })
            );
          }
        } else {
          instances.forEach(i => i.cleanup());
          instances = [];
        }
      };

      toggleSticky(mq);

      mq.addEventListener
        ? mq.addEventListener('change', toggleSticky)
        : mq.addListener(toggleSticky);
    });
  };

  const cleanupSticky = () => {
    instances.forEach(i => i.cleanup());
    instances = [];
  };

  initSticky();

  const observer = new MutationObserver(() => {
    if (topbar.classList.contains('is-narrow')) {
      cleanupSticky();
      initSticky();
    }
  });

  observer.observe(topbar, {
    attributes: true,
    attributeFilter: ['class']
  });
});
